import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

const getUserLastName = createSelector(
  // @ts-ignore
  (state: State) => state.findUser.userInfo,
  (userInfo): string => {
    // @ts-ignore
    if (userInfo.data) {
      // @ts-ignore
      return userInfo.data[0].last_name.charAt(0).toUpperCase() + userInfo.data[0].last_name.toLowerCase().slice(1);
    } else {
      return null;
    }
  }
);

export default getUserLastName;
